import axios from "axios";

export const swrFetcher = ([url, params]) => axios.get(url, {params}).then(res => res.data);